import { render, staticRenderFns } from "./editPaper.vue?vue&type=template&id=4c4ed855&scoped=true"
import script from "./editPaper.vue?vue&type=script&lang=js"
export * from "./editPaper.vue?vue&type=script&lang=js"
import style0 from "./editPaper.vue?vue&type=style&index=0&id=4c4ed855&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ed855",
  null
  
)

export default component.exports